import PropTypes from 'prop-types';
import React, { useState } from 'react';
import dayjs from 'dayjs';
import Image from '$partials/media/image';


const ArticleItem = ({
    title,
    listingImage,
    url,
    publicationDate,
    authors,
    tags
}) => {

    const [ showAllTags, setShowAllTags ] = useState(false);

    return (
        <div className='expand-interaction bg-white hover:bg-peach'>

            {/* mobile */}
            <section className='sm:hidden layout-container border-t border-t-charcoal'>
                <div className='layout-grid-negative-gutter'>
                    <div className='layout-grid-col-padding py-30'>
                        <div className='pb-30'>
                            {listingImage && (
                                <figure className='float-left w-80 mr-10'>
                                    <Image
                                        containerClassName=''
                                        {...listingImage}
                                        alt={listingImage.alt} />
                                </figure>
                            )}
                            <h3 className='type-style-3'>
                                <div className='h-20' />
                                <a
                                    className='expand-interaction__action'
                                    href={url}>
                                    {title}
                                </a>
                            </h3>
                        </div>

                        <div className=''>
                            {authors?.edges?.length > 0 && (
                                <span className='type-style-4'>Written by&nbsp;</span>
                            )}
                            {authors?.edges.map(({ node: item }, idx) => {
                                const isLast = idx === authors.edges.length-1;
                                return (
                                    <span
                                        className='type-style-4'
                                        key={idx}>
                                        {isLast ? item.title : item.title + ',' + String.fromCharCode(160)}
                                    </span>
                                );
                            })}
                            <p className='type-style-4 pt-20 pb-40'>{dayjs(publicationDate).format('D MMMM, YYYY')}</p>
                        </div>

                        <div className='flex gap-10'>
                            {tags?.length <= 1 && tags.map((item, idx) => {
                                return (
                                    <a
                                        className='pill-button'
                                        href={item.url}
                                        key={idx}>
                                        {item.title}
                                    </a>
                                );
                            })}
                            {tags?.length > 1 && tags.slice(0, 1).map((item, idx) => {
                                return (
                                    <a
                                        className='pill-button'
                                        href={item.url}
                                        key={idx}>
                                        {item.title}
                                    </a>
                                );
                            })}
                            {tags?.length > 1 && (
                                <button
                                    className={`${showAllTags ? 'hidden' : 'pill-button'}`}
                                    onClick={() => {
                                        setShowAllTags(true);
                                    }}
                                    type='button'>
                                    &hellip;
                                </button>
                            )}
                            {showAllTags && tags.slice(1).map((item, idx) => {
                                return (
                                    <a
                                        className='pill-button'
                                        href={item.url}
                                        key={idx}>
                                        {item.title}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>

            {/* tablet */}
            <section className='hidden sm:block md:hidden layout-container border-t border-t-charcoal '>
                <div className='layout-grid-negative-gutter'>
                    <div
                        className='py-30'>
                        <div className='flex'>
                            <div className='pb-30 w-6/12 layout-grid-col-padding'>
                                {listingImage && (
                                    <figure className='float-left w-80 mr-10'>
                                        <Image
                                            containerClassName=''
                                            {...listingImage}
                                            alt={listingImage.alt} />
                                    </figure>
                                )}
                                <h3 className='type-style-3'>
                                    <div className='h-20' />
                                    <a
                                        className='expand-interaction__action'
                                        href={url}>
                                        {title}
                                    </a>
                                </h3>
                            </div>

                            <div className='w-6/12 layout-grid-col-padding'>
                                {authors?.edges?.length > 0 && (
                                    <span className='type-style-4'>Written by </span>
                                )}
                                {authors?.edges.map(({ node: item }, idx) => {
                                    const isLast = idx === authors.edges.length-1;
                                    return (
                                        <span
                                            className='type-style-4'
                                            key={idx}>
                                            {isLast ? item.title : item.title + ', '}
                                        </span>
                                    );
                                })}
                                <p className='type-style-4 pt-20 pb-40'>{dayjs(publicationDate).format('D MMMM, YYYY')}</p>
                            </div>
                        </div>

                        <div className='flex gap-10 w-12/12 layout-grid-col-padding'>
                            {tags?.length <= 1 && tags.map((item, idx) => {
                                return (
                                    <a
                                        className='pill-button'
                                        href={item.url}
                                        key={idx}>
                                        {item.title}
                                    </a>
                                );
                            })}
                            {tags?.length > 1 && tags.slice(0, 1).map((item, idx) => {
                                return (
                                    <a
                                        className='pill-button'
                                        href={item.url}
                                        key={idx}>
                                        {item.title}
                                    </a>
                                );
                            })}
                            {tags?.length > 1 && (
                                <button
                                    className={`${showAllTags ? 'hidden' : 'pill-button'}`}
                                    onClick={() => {
                                        setShowAllTags(true);
                                    }}
                                    type='button'>
                                    &hellip;
                                </button>
                            )}
                            {showAllTags && tags.slice(1).map((item, idx) => {
                                return (
                                    <a
                                        className='pill-button'
                                        href={item.url}
                                        key={idx}>
                                        {item.title}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>

            {/* desktop */}
            <section className='hidden md:block layout-container border-t border-t-charcoal py-40'>
                <div className='layout-grid-negative-gutter md:flex'>
                    <div className='md:w-1/12 layout-grid-col-padding' />
                    <div className='flex items-center md:w-11/12'>
                        <h3 className='type-style-3 w-4/11 layout-grid-col-padding'>
                            <a
                                className='expand-interaction__action'
                                href={url}>
                                {title}
                            </a>
                        </h3>
                        {listingImage && (
                            <figure className='w-1/11 layout-grid-col-padding float-left'>
                                <Image
                                    containerClassName=''
                                    {...listingImage}
                                    alt={listingImage.alt} />
                            </figure>
                        )}

                        <div className='w-3/11 layout-grid-col-padding'>
                            {authors?.edges?.length > 0 && (
                                <span className='type-style-4'>Written by </span>
                            )}
                            {authors?.edges.map(({ node: item }, idx) => {
                                const isLast = idx === authors.edges.length-1;
                                return (
                                    <span
                                        className='type-style-4'
                                        key={idx}>
                                        {isLast ? item.title : item.title + ', '}
                                    </span>
                                );
                            })}
                            <p className='type-style-4'>{dayjs(publicationDate).format('D MMMM, YYYY')}</p>
                        </div>

                        <div className='w-3/11 layout-grid-col-padding flex flex-wrap gap-10'>
                            {tags?.length <= 1 && tags.map((item, idx) => {
                                return (
                                    <a
                                        className='pill-button'
                                        href={item.url}
                                        key={idx}>
                                        {item.title}
                                    </a>
                                );
                            })}
                            {tags?.length > 1 && tags.slice(0, 1).map((item, idx) => {
                                return (
                                    <a
                                        className='pill-button'
                                        href={item.url}
                                        key={idx}>
                                        {item.title}
                                    </a>
                                );
                            })}
                            {tags?.length > 1 && (
                                <button
                                    className={`${showAllTags ? 'hidden' : 'pill-button'}`}
                                    onClick={() => {
                                        setShowAllTags(true);
                                    }}
                                    type='button'>
                                    &hellip;
                                </button>
                            )}
                            {showAllTags && tags?.slice(1).map((item, idx) => {
                                return (
                                    <a
                                        className='pill-button'
                                        href={item.url}
                                        key={idx}>
                                        {item.title}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>

        </div>

    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    title: PropTypes.string,
    listingImage: PropTypes.object,
    url: PropTypes.string,
    publicationDate: PropTypes.string,
    authors: PropTypes.object,
    tags: PropTypes.array
};

ArticleItem.propTypes = propTypes;

export default ArticleItem;
